import React, { Component } from 'react';
import { InfoIcon } from 'lucide-react';
interface ComboProduct {
  id: number;
  name: string;
  price: number;
  quantity: number;
  image: string;
}
interface ComboComponentsProps {
  products?: ComboProduct[];
}
export function ComboComponents({
  products
}: ComboComponentsProps) {
  const defaultProducts: ComboProduct[] = [{
    id: 1,
    name: 'Vitamin C 1000mg High Strength ...',
    price: 39.0,
    quantity: 1,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/9saiuVEon1B9shifj9M2b6/image.png'
  }, {
    id: 2,
    name: 'Omega 3 Fish Oil - 90 Capsules Ri...',
    price: 59.0,
    quantity: 2,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/9wk731B1V7mHp2LRAe2uVA/image.png'
  }, {
    id: 3,
    name: 'Magnesium 400mg High Absorpt...',
    price: 49.0,
    quantity: 3,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/eBtMsQvDChgNTk43U7k9yq/image.png'
  }];
  const comboProducts = products || defaultProducts;
  return <div className="bg-white rounded-lg border border-gray-200 p-4 mb-4" data-id="element-5381" data-mp="uwug1d60rdkm">
      <h3 className="text-base font-bold text-gray-900 mb-4" data-id="element-5382" data-mp="z0sdljfp4gbk">
        Combo Components
      </h3>
      <div className="space-y-3" data-id="element-5383" data-mp="13xsp49vbeba2">
        {comboProducts.map(product => <div key={product.id} className="flex items-center gap-3 pb-3 border-b border-gray-100 last:border-b-0 last:pb-0" data-id="element-5384" data-mp="18r3ue6khajzv">
            {/* Product Image */}
            <div className="flex-shrink-0 w-12 h-12 bg-gray-50 rounded overflow-hidden" data-id="element-5385" data-mp="1in6y3guzaqox">
              <img src={product.image} alt={product.name} className="w-full h-full object-contain" data-id="element-5386" data-mp="1mplezvf37gdk" />
            </div>
            {/* Product Details */}
            <div className="flex-1 min-w-0" data-id="element-5387" data-mp="3oii0kc6mi1bx">
              <h4 className="text-sm font-medium text-gray-900 truncate mb-1" data-id="element-5388" data-mp="3ojkqohw4fzqs">
                {product.name}
              </h4>
              <p className="text-sm font-bold text-gray-900" data-id="element-5389" data-mp="10laxwi67zlzw">
                SAR {product.price.toFixed(2)}
              </p>
              <p className="text-xs text-blue-600" data-id="element-5390" data-mp="vo1a16yhbie6">
                Quantity: {product.quantity}
              </p>
            </div>
            {/* Info Button */}
            <button className="flex-shrink-0 w-6 h-6 rounded-full bg-gray-600 hover:bg-gray-700 flex items-center justify-center transition-colors" data-id="element-5391" data-mp="14mwi6ol332k4">
              <InfoIcon className="w-4 h-4 text-white" data-id="element-5392" data-mp="1jiua1unz5kqj" />
            </button>
          </div>)}
      </div>
    </div>;
}